<template>
  <div
    :class="cssClass.parent"
    @click="click"
    @mouseenter="setTooltipPosition"
    @mouseleave="hideTooltip"
    ref="parent"
  >
    <Icon2 v-if="icon[variant]" :variant="icon[variant]" :size="16" />
    <portal to="portal-tooltip" v-if="isHover">
      <div :class="cssClass.content" ref="content">
        <slot></slot>
      </div>
    </portal>
  </div>
</template>

<script>
import Icon2 from '@/components/Icon2';
import { computePosition, autoPlacement, offset } from '@floating-ui/dom';

export default {
  props: {
    size: {
      type: String,
      required: false
    },
    variant: {
      type: String,
      required: false,
      default: 'question'
    },
    position: {
      type: String,
      required: false
    }
  },
  components: {
    Icon2
  },
  data() {
    return {
      icon: {
        attention: 'attention',
        question: 'question-square'
      },
      isHover: false
    };
  },
  computed: {
    cssClass() {
      return {
        parent: {
          'c-tooltip': true,
          ['c-tooltip--' + this.size]: this.size,
          ['c-tooltip--' + this.variant]: this.variant
        },
        content: {
          'c-tooltip__content': true,
          ['c-tooltip--' + this.variant + '__content']: this.variant,
          ['c-tooltip__content__' + this.position]: this.position
        }
      };
    }
  },
  methods: {
    click(e) {
      this.$emit('click', e);
    },
    hideTooltip() {
      this.isHover = false;
    },
    setTooltipPosition() {
      this.isHover = true;
      this.$nextTick(() => {
        const parent = this.$refs.parent;
        const content = this.$refs.content;
        if (!parent || !content) {
          return;
        }
        computePosition(parent, content, {
          placement: 'top-end',
          middleware: [
            autoPlacement({
              allowedPlacements: ['top-start', 'top-end']
            }),
            offset(5)
          ],
          strategy: 'fixed'
        }).then(({ x, y }) => {
          Object.assign(content.style, { left: `${x}px`, top: `${y}px` });
        });
      });
    }
  }
};
</script>
